import { Redirect } from "expo-router";

export default function LegacyArrangementStudioRoute() {
  return <Redirect href="/demo/monarch/arrangements/welcome" />;
}

